import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { base_url } from "../../utils/utils";

export const get_pay_run_list = createAsyncThunk(
  "pay_run_list",
  async ({ body, data }) => {
    try {
      const response = await fetch(`${base_url}payroll/payrun.php`, {
        method: "POST",
        body: JSON.stringify(body),
      });
      const res = await response.json();
      if (res.success) {
        data?.setTotalCount(res?.totalcount);
        data?.setSearchCount(res?.searchcount);
      }
      return res;
    } catch (error) {
      console.error("Error fetching data:", error?.message);
    }
  }
);

export const get_loans_list = createAsyncThunk(
  "loans_list",
  async ({ body, data }) => {
    try {
      const response = await fetch(`${base_url}payroll/staffLoanData.php`, {
        method: "POST",
        body: JSON.stringify(body),
      });
      const res = await response.json();
      if (res.success) {
        data?.setTotalCount(res?.totalcount);
        data?.setSearchCount(res?.searchcount);
      }
      return res;
    } catch (error) {
      console.error("Error fetching data:", error?.message);
    }
  }
);
export const get_advance_list = createAsyncThunk(
  "advance_list",
  async ({ body, data }) => {
    try {
      const response = await fetch(`${base_url}payroll/staffAdvanceData.php`, {
        method: "POST",
        body: JSON.stringify(body),
      });
      const res = await response.json();
      if (res.success) {
        data?.setTotalCount(res?.totalcount);
        data?.setSearchCount(res?.searchcount);
      }
      return res;
    } catch (error) {
      console.error("Error fetching data:", error?.message);
    }
  }
);

export const get_payroll_report = createAsyncThunk(
  "reports",
  async ({ body, data }) => {
    try {
      const response = await fetch(`${base_url}payroll/payrollReports.php`, {
        method: "POST",
        body: JSON.stringify(body),
      });
      const res = await response.json();
      if (res.success) {
        data?.setTotalCount(res?.totalcount);
        data?.setSearchCount(res?.searchcount);
      }
      return res;
    } catch (error) {
      console.error("Error fetching data:", error?.message);
    }
  }
);

const initialState = {
  staff_payroll_list: [],
  staff_payroll_loading: false,
  pay_run_list: [],
  pay_run_loading: false,
  loans_list: [],
  loans_loading: false,
  advance_list: [],
  advance_loading: false,
  payroll_report_list: [],
  payroll_report_loading: false,
};

const payrollSlice = createSlice({
  name: "payrollSlice",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(get_pay_run_list.pending, (state, action) => {
        state.pay_run_loading = true;
      })
      .addCase(get_pay_run_list.fulfilled, (state, action) => {
        const data = action.payload;
        state.pay_run_loading = false;
        if (data.success) {
          state.pay_run_list = data.data;
        } else {
          state.pay_run_list = [];
        }
      })
      .addCase(get_pay_run_list.rejected, (state, action) => {
        state.pay_run_loading = false;
      });

    builder
      .addCase(get_loans_list.pending, (state, action) => {
        state.loans_loading = true;
      })
      .addCase(get_loans_list.fulfilled, (state, action) => {
        const data = action.payload;
        state.loans_loading = false;
        if (data?.success) {
          state.loans_list = data.data;
        } else {
          state.loans_list = [];
        }
      })
      .addCase(get_loans_list.rejected, (state, action) => {
        state.loans_loading = false;
      });

      builder
      .addCase(get_advance_list.pending, (state, action) => {
        state.advance_loading = true;
      })
      .addCase(get_advance_list.fulfilled, (state, action) => {
        const data = action.payload;
        state.advance_loading = false;
        if (data?.success) {
          state.advance_list = data.data;
        } else {
          state.advance_list = [];
        }
      })
      .addCase(get_advance_list.rejected, (state, action) => {
        state.advance_loading = false;
      });

    builder
      .addCase(get_payroll_report.pending, (state, action) => {
        state.payroll_report_loading = true;
      })
      .addCase(get_payroll_report.fulfilled, (state, action) => {
        const data = action.payload;
        state.payroll_report_loading = false;
        if (data?.success) {
          state.payroll_report_list = data.data || [];
        } else {
          state.payroll_report_list = [];
        }
      })
      .addCase(get_payroll_report.rejected, (state, action) => {
        state.payroll_report_loading = false;
      });
  },
});

export default payrollSlice.reducer;
